export const QSET_REVIEW_TASK_CREATION_STEP = {
  selectExamCourse: 'Select Exam Course',
  selectQSet: 'Select QSet',
  addTaskDetails: 'Add Task Details',
};
export const REVIEW_QSET_TASK_CREATION_SEQUENCES = [
  QSET_REVIEW_TASK_CREATION_STEP.selectExamCourse,
  QSET_REVIEW_TASK_CREATION_STEP.selectQSet,
  QSET_REVIEW_TASK_CREATION_STEP.addTaskDetails,
];
